import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormGroup, FormControlLabel, useTheme } from '@mui/material';
import { find, compact, map } from 'lodash';
import DefaultLogo from '@shared/assets/air/iconBlack.png';

import {
  SecondaryCheckbox,
  StyledButton,
  AirlineLabel,
  AirlineIcon,
} from './styles';

const AirlineFilters = ({ flexibleSearchResult }) => {
  const theme = useTheme();
  const infoFlightsSearchBody = useSelector(store => store.flightsSearchBody);

  const threeDaysCarriers = flexibleSearchResult
    ? Object.keys(flexibleSearchResult?.carriers ?? {}).map(el => {
        const it = flexibleSearchResult?.carriers[el];
        return {
          code: it.code,
          logo: it.airline_logo,
          name: it.description,
        };
      })
    : [];

  const initCarrierState = threeDaysCarriers?.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.code]: !!flexibleSearchResult?.chosen_airlines?.find(
        x => x === cur.code
      ),
    }),
    {}
  );

  const [carriersStates, setCarriersStates] = useState(initCarrierState);
  const [disabledButton, setDisabledButton] = useState(true);
  const [hideButton, setHideButton] = useState(true);

  const handleChange = event => {
    setCarriersStates({
      ...carriersStates,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const shouldDisable = !find(carriersStates);
    setDisabledButton(shouldDisable);
  }, [carriersStates]);

  useEffect(() => {
    if (window.vthws)
      window.vthws.enableAnotherSerch = () => {
        setHideButton(false);
      };
  }, []);

  const handleSubmitAirlineFilters = () => {
    const chosenAirlines = compact(
      map(carriersStates, (x, y) => (x ? y : null))
    );
    const newinfoFlightsSearchBody = {
      ...infoFlightsSearchBody,
      chosen_airlines: chosenAirlines,
      carriers: threeDaysCarriers,
    };

    if (window.vthws) window.vthws.webSerch(newinfoFlightsSearchBody);
    setHideButton(true);
  };

  // Crear instancias de los styled components pasando theme
  const CheckboxStyled = SecondaryCheckbox(theme);
  const ButtonStyled = StyledButton(theme);
  const LabelStyled = AirlineLabel(theme);
  const IconStyled = AirlineIcon(theme);

  return (
    <>
      <FormGroup row sx={{ p: 1 }}>
        {threeDaysCarriers?.map(x => (
          <FormControlLabel
            key={`check${x.code}`}
            control={
              <CheckboxStyled
                checked={carriersStates[x.code]}
                onChange={handleChange}
                name={x.code}
                value={x.code}
              />
            }
            label={
              <LabelStyled style={{ fontSize: '14px' }}>
                <IconStyled src={x.logo || DefaultLogo} alt="aerolineas" />
                {x.name ? x.name.toLowerCase() : x.code}
              </LabelStyled>
            }
          />
        ))}
      </FormGroup>

      {!hideButton && (
        <ButtonStyled
          variant="contained"
          disabled={disabledButton || window.vthws?.searching}
          onClick={handleSubmitAirlineFilters}
        >
          Buscar
        </ButtonStyled>
      )}
    </>
  );
};

export default AirlineFilters;
